import {
  RAISE_API_V1_URL,
  RAISE_BASE_URL,
  RAISE_QUERY_URL
} from "constants/endpoints";
import { get, post } from "services/api";

const getApiCartUrl = () => {
  const baseUrl = RAISE_API_V1_URL;
  return `${baseUrl}/cart`;
};

// TODO check if this function is deprecated
export const addNewCard = async ({
  card_details,
  legacy_card_id,
  price,
  user_uuid
}) => {
  const url = `${RAISE_QUERY_URL}?type=addCard`;
  const body = JSON.stringify({
    card_details,
    legacy_card_id,
    price,
    user_uuid
  });

  const response = await post(url, body);
  return response.data;
};

export const addBulkCards = async ({ cards }) => {
  const url = `${RAISE_QUERY_URL}?type=addMultipleCards`;
  const body = JSON.stringify({ cards });

  const response = await post(url, body);
  return response.data;
};

export const mountCart = async ({
  user_uuid,
  product_source_id,
  discount,
  value,
  quantity
}) => {
  const url = getApiCartUrl();
  const body = {
    user_uuid,
    product_source_id,
    value,
    discount,
    quantity
  };

  const response = await post(url, body, {
    headers: {
      Authorization: `Bearer ${btoa(user_uuid + product_source_id)}`
    }
  });
  return response.data;
};

export const removeCard = async ({ brand_uuid, listing_uuid, user_uuid }) => {
  const url = `${getApiCartUrl()}/remove`;
  const params = { brand_uuid, listing_uuid, user_uuid };

  const response = await post(url, null, { params });
  return response.data;
};

export const validateServiceResponse = async (response) => {
  if (response.ok) return;

  let result;

  try {
    result = response.data;
    return result;
  } catch (err) {
    result = err;
  }

  throw result;
};

export const getBrand = async (brandUuid) => {
  const url = `${RAISE_QUERY_URL}?type=brandData&brand_uuid=${brandUuid}`;

  const response = await get(url);

  const data = response.data;
  return data.brand;
};

/**
 *
 * @returns {Promise<{
 *  product_source: {
 *    id: number,
 *    name: string,
 *    terms: string,
 *    affiliate_url: string,
 *    card_type: {
 *      electronic_online: Boolean,
 *      electronic_voucher: Boolean,
 *      instructions: string,
 *    }
 *  }
 * }>} - an Object containing product source infos
 */
export const getAffiliateUrl = async ({ slug }) => {
  const url = `${RAISE_BASE_URL}/buy-${slug}-gift-cards.json`;
  const params = {
    group_listings: true
  };

  const response = await get(url, { params });
  return response.data.product_source.affiliate_url;
};

/**
 * Returns a Promise that resolves to an object with item and shopping basket information.
 * @returns {Promise<{
 *   items: Array<{
 *     uuid: string,
 *     user_uuid: string,
 *     listing_uuid: string,
 *     brand_uuid: string,
 *     reserved_until: string,
 *     created_at: string,
 *     updated_at: string,
 *     price: number,
 *     server_time: string,
 *     card_details: string,
 *     brand_slug: string
 *   }>,
 *   reserved_until: string,
 *   total: number,
 *   promo: string | null,
 *   basket_uuid: string | null,
 *   server_time: string
 * }>} - An object containing item details and shopping basket information.
 */
export const getCards = async ({ uuid }) => {
  const url = getApiCartUrl();
  const params = { uuid };

  const response = await get(url, { params });
  return response.data;
};

export const emptyCart = async ({ uuid }) => {
  const url = `${getApiCartUrl()}/empty_cart`;
  const params = { uuid };

  const response = await post(url, null, { params });
  return response.data;
};
